//Please add the language resource
const carrier = {
  carrierCode: 'carrierCode',
  carrierName: 'carrierName',
  carrierShortName: 'carrierShortName',
  companyCode: 'companyCode',
  companyName: 'companyName',
  contactMan: 'contactMan',
  contactTel: 'contactTel',
  contactMail: 'contactMail',
  contactMobile: 'contactMobile',
  contactAddr: 'contactAddr',
  createTime: 'createTime',
  creator: 'creator',
  updateTime: 'updateTime',
  updater: 'updater',
  useCompanyName: 'useCompanyName',
  msg: {}
};
export default carrier



// WEBPACK FOOTER //
// ./src/page/mdm/carrier/lang/carrier.en.js